import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { useScrollReveal } from "../hooks/useScrollReveal";
import usePageSeo from "../hooks/usePageSeo";
import { projectsData } from "./projectsData";
import "./Projects.css";

export default function Projects() {
  useScrollReveal();
  const { t, lang } = useLang();

  usePageSeo({
    lang,
    path: "/projects",
    title: lang === "IT"
      ? "Progetti | Lavori e realizzazioni GDM Installations"
      : "Projects | GDM Installations works and creations",
    description: lang === "IT"
      ? "Esplora una selezione di progetti e realizzazioni GDM Installations tra arredi su misura, ambienti residenziali e spazi professionali."
      : "Explore a selection of GDM Installations projects featuring bespoke furniture, residential interiors and professional spaces.",
    keywords: lang === "IT"
      ? "progetti falegnameria, realizzazioni arredi su misura, portfolio GDM Installations, lavori legno Bari"
      : "carpentry projects, bespoke furniture portfolio, GDM Installations works, wood craftsmanship Bari",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: lang === "IT" ? "Progetti GDM Installations" : "GDM Installations Projects",
      url: "https://gdminstallations.it/projects",
      hasPart: projectsData.map((project) => ({
        "@type": "CreativeWork",
        name: lang === "IT" ? project.title_IT : project.title_EN,
        url: `https://gdminstallations.it/projects/${project.id}`,
        image: project.img,
      })),
    },
  });

  return (
    <div className="projects-page">
      <div className="page-hero-mini">
        <h1 className="page-hero-title fade-in">{t.projects.title}</h1>
        <div className="gold-line" />
        <p className="page-hero-sub fade-in fade-in-delay-1">{t.projects.subtitle}</p>
      </div>

      <section className="projects-section section">
        <div className="section-inner">
          <div className="projects-grid">
            {projectsData.map((p, i) => (
              <Link
                to={`/projects/${p.id}`}
                key={p.id}
                className={`project-card reveal-scale fade-in-delay-${(i % 3) + 1}`}
              >
                <div className="project-card-img">
                  <img src={p.img} alt={lang === "IT" ? p.title_IT : p.title_EN} />
                </div>
                <div className="project-card-body">
                  <h3>{lang === "IT" ? p.title_IT : p.title_EN}</h3>
                  <div className="gold-line-left" style={{ width: "40px", margin: "0.8rem 0" }} />
                  <p>{(lang === "IT" ? p.desc_IT : p.desc_EN).slice(0, 120)}...</p>
                  <span className="project-read-more">{t.projects.readMore} →</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
